export default {
  SET_ERROR: 'SET_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  SET_INFO: 'SET_INFO',
  RESET_INFO: 'RESET_INFO',
  SET_SUCCESS_MESSAGE: 'SET_SUCCESS_MESSAGE',
  RESET_SUCCESS_MESSAGE: 'RESET_SUCCESS_MESSAGE',
  TOGGLE_MUTE: 'TOGGLE_MUTE',
  DISABLE_VIDEO: 'DISABLE_VIDEO',
  IS_API_PROGRESS: 'IS_API_PROGRESS',
  SET_SELECTED_RATING: 'SET_SELECTED_RATING',
  RATING_SUCCESS: 'RATING_SUCCESS',
  FEEDBACK_TYPES: 'FEEDBACK_TYPES',
  SET_FEEDBACK_STATUS: 'SET_FEEDBACK_STATUS',
  SET_LANDING_PAGE_LANGUAGE: 'SET_LANDING_PAGE_LANGUAGE',
};
